module.exports = __webpack_public_path__ + "img/close2.8c1910ae.svg";